import { safeDefine } from "../../registration/safe-define.js";
import { DialogDescriptionElement } from "../../ui/dialog/description.js";
//#region src/define/ui/dialog-description.ts
safeDefine(DialogDescriptionElement);
//#endregion

//# sourceMappingURL=dialog-description.js.map